import { useFetchers, useNavigation } from "@remix-run/react";

import styles from "./Loader.module.scss";

export default function Loader() {
  const navigation = useNavigation();
  const loadingPage = navigation.state === "loading";

  const fetchers = useFetchers();

  const isSubmitting = fetchers.some((f) => f.state === "submitting");

  const loading = isSubmitting || loadingPage;

  return (
    <>
      {loading && (
        <div className={styles.container}>
          <div className={styles.loader} />
        </div>
      )}
    </>
  );
}
